<div class="alterar-modelo-section">
    <div class="alterar-modelo-header">
        <mat-icon class="material-symbols-outlined">swap_horiz</mat-icon>
        <span>{{ isModoEditor ? 'Selecionar modelo para esta configuração' : 'Selecionar modelo de cálculo' }}</span>
    </div>

    <p class="alterar-modelo-hint text-secondary">
        @if (isModoEditor) {
        A seleção abaixo vale apenas para esta configuração e não altera o modelo padrão global.
        } @else {
        Selecione o modelo de cálculo que será usado como padrão. O modelo padrão do sistema é aplicado
        quando nenhuma personalização está ativa.
        }
    </p>

    <div class="modelos-grid">
        @for (modelo of modelos; track modelo.chaveFormulaModelo) {
        <app-formula-modelo-card
            [modelo]="modelo"
            [versoes]="versoesDaFamilia(modelo)"
            [rotuloModelo]="rotuloModelo(modelo)"
            [variaveis]="formula.variaveis"
            [mostrarVigencia]="isModoListagem"
            [modo]="modo"
            [idModeloPadrao]="idModeloPadrao"
            [selecionado]="selecionadoLocal === modelo.chaveFormulaModelo"
            (selecionar)="selecionar(modelo)">
        </app-formula-modelo-card>
        }
    </div>
</div>
